module.exports = __webpack_public_path__ + "static/media/logo-mobile.85c62b54.png";